import { isDateOnly } from '@agroone/dates'
import { ValidatorConstraint, ValidatorConstraintInterface } from 'class-validator'

/**
 * A date-only value (`YYYY-MM-DD`). Also accepts the ISO 8601 payloads that clients sent for these fields before they
 * moved to `YYYY-MM-DD` (`2026-07-20T00:00:00+02:00`): only their calendar part is kept, see `parseDateOnly`.
 * Use with `@Validate(IsDateOnly)`.
 */
@ValidatorConstraint({ name: 'isDateOnly', async: false })
export class IsDateOnly implements ValidatorConstraintInterface {
  validate(value: unknown): boolean {
    return isDateOnly(value)
  }

  defaultMessage(): string {
    return 'Date "$value" must be a date-only value with the format YYYY-MM-DD (eg 2026-07-20)'
  }
}
